// ============================================================
// HostessTasks 多主题样式配置
// 供 DailyTasks.vue 和 NewTasks.vue 共同使用
// ============================================================

import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    // ---- index.vue 页面级 ----
    '--theme-page-bg': 'linear-gradient(90deg, #c761fe 0%, #8c59fb 100%)', // 顶部背景（root + nav）
    '--theme-main-content-bg': '#ffffff', // 任务内容区背景色
    '--theme-skip-dia-bg': '#a338fc', // 跳过任务弹窗

    // ---- 通用颜色（DailyTasks + NewTasks 共用）----
    '--theme-title-count-color': '#be60fd', // 标题计数 i 标签颜色
    '--theme-progress-color': '#c761fe', // 进度条填充色
    '--theme-pivot-color': '#b366fa', // 进度条 pivot 气泡颜色
    '--theme-progress-track-color': '#ffffff', // 进度条轨道色（DailyTasks 专用，NewTasks 固定 #ffffff）
    '--theme-task-list-bg': '#f8f3fa', // 任务条目背景色
    '--theme-lock-highlight': '#a554f7', // 锁定提示高亮色
    '--theme-arrow-btn-bg': 'linear-gradient(90deg, #c47dff 0%, #a250f6 100%)', // 箭头按钮渐变
    '--theme-success-btn-bg': 'linear-gradient(90deg, #fdd305 0%, #ffba27 100%)', // 领取按钮渐变
    '--theme-node-bg': '#f4daff', // 进度节点圆点背景色

    // ---- DailyTasks 周任务专用 ----
    '--theme-day-not-start-bg': '#fbe8ff', // 周任务未开始的日期格背景

    // ---- 奖励弹窗（DailyTasks + NewTasks 共用）----
    '--theme-reward-btn-color': '#ffffff', // 奖励弹窗按钮文字色
    '--theme-reward-btn-bg': '#a338fc', // 奖励弹窗按钮背景色

    // ---- 图片：DailyTasks 周任务专用 ----
    '--theme-notstarted-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/default/not_started_icon.webp')})`,
    '--theme-complete-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/default/complete_icon.webp')})`,
    '--theme-lock-flag': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/default/lock_flag.webp')})`,

    // ---- 图片：NewTasks + DailyTasks 共用 ----
    '--theme-success-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/default/success_icon.webp')})`,
  },

  kiko: {
    // ---- index.vue 页面级 ----
    '--theme-page-bg': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/kiko/topbg.webp')}) top left / 100% auto no-repeat`, // 顶部背景（root + nav）
    '--theme-main-content-bg': '#f9f9fb', // 任务内容区背景色
    '--theme-skip-dia-bg': '#ffa641', // 跳过任务弹窗

    // ---- 通用颜色（DailyTasks + NewTasks 共用）----
    '--theme-title-count-color': '#ff8a33',
    '--theme-progress-color': '#ff8a33',
    '--theme-pivot-color': '#ff8a33',
    '--theme-progress-track-color': '#E7E7E9', // DailyTasks kiko 专用，NewTasks 固定 #ffffff
    '--theme-task-list-bg': '#eeeef1',
    '--theme-lock-highlight': '#ff8a33',
    '--theme-arrow-btn-bg': 'linear-gradient(90deg, #ffdf7d 0%, #ffa641 100%)',
    '--theme-success-btn-bg': 'linear-gradient(270deg, #f03bff 0%, #ffa450 100%)',
    '--theme-node-bg': '#cccccc',

    // ---- DailyTasks 周任务专用 ----
    '--theme-day-not-start-bg': '#fffce6',

    // ---- 奖励弹窗（DailyTasks + NewTasks 共用）----
    '--theme-reward-btn-color': '#000000',
    '--theme-reward-btn-bg': '#ffe242',

    // ---- 图片：DailyTasks 周任务专用 ----
    '--theme-notstarted-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/kiko/not_started_icon.webp')})`,
    '--theme-complete-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/kiko/complete_icon.webp')})`,
    '--theme-lock-flag': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/kiko/lock_flag.webp')})`,

    // ---- 图片：NewTasks + DailyTasks 共用 ----
    '--theme-success-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessTasks/kiko/success_icon.webp')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        // 未配置
        else {
          return { ...getBaseFeature(), ...styObj['default'] }
        }
      }
      return { ...getBaseFeature() }
    },
  },
}
